/* @flow */
import React from 'react';
import classnames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

// Components
import Close from 'dibs-vg/dist/react/close';

import type { QuickViewItem_item as QuickViewItemProp } from './__generated__/QuickViewItem_item.graphql';

// Styles
import styles from './styles.scss';

type QuickViewItemProps = {|
    item: QuickViewItemProp,
    isQuickViewActive: boolean,
    onClose: () => void,
    isMobile?: boolean,
|};

type QuickViewItemState = {|
    isQuickViewActive: boolean,
|};

class QuickViewItem extends React.Component<QuickViewItemProps, QuickViewItemState> {
    constructor() {
        super();

        this.state = {
            isQuickViewActive: false,
        };
    }

    componentDidUpdate(prevProps) {
        const { isQuickViewActive } = this.props;
        if (prevProps.isQuickViewActive !== isQuickViewActive) {
            this.setState({ isQuickViewActive });
        }
    }

    render() {
        const { item, onClose, isMobile } = this.props;
        const { isQuickViewActive } = this.state;

        /* istanbul ignore if */
        if (!item.quickViewDisplay) {
            return null;
        }

        const mobileTitle = get(item, 'quickViewDisplay.mobileTitle');
        const title = get(item, 'quickViewDisplay.title');
        const paragraphs = get(item, 'quickViewDisplay.paragraphs');
        const quickViewClass = classnames(styles.wrapper, {
            [styles.isActive]: isQuickViewActive,
        });

        return (
            <div className={quickViewClass}>
                <div className={styles.item}>
                    <div className={styles.close} onClick={onClose}>
                        <Close />
                    </div>
                    <div className={styles.content}>
                        <div className={styles.title}>{isMobile ? mobileTitle : title}</div>
                        {!!paragraphs &&
                            paragraphs.map(paragraph => (
                                <div className={styles.paragraph} key={paragraph.key}>
                                    {isMobile ? paragraph.mobileText : paragraph.text}
                                </div>
                            ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default createFragmentContainer(QuickViewItem, {
    item: graphql`
        fragment QuickViewItem_item on Item {
            quickViewDisplay {
                title
                mobileTitle: title(formatType: MOBILE)
                paragraphs {
                    key
                    text
                    mobileText: text(formatType: MOBILE)
                }
            }
        }
    `,
});
